import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.58.1_babel-plugin_odjefa34hcwkhiw6smi3fnpf3a/node_modules/next/dist/client/script.js");
